/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/rooms",
    },
    (router) => {
      router.group(
        {
          path: "/:hotelRoomId",
        },
        (router) => {
          router.push({
            id: "@api/hotel.room@view",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel.room@duplicate",
                path: "/duplicate",
              });
            },
          );
        },
      );

      router.group({ path: "/action" }, (router) => {
        router.push({
          id: "@api/hotel.room@autocomplete",
          path: "/autocomplete",
        });
      });
    },
  );
}
